import { render, staticRenderFns } from "./DetailedDescription.vue?vue&type=template&id=ad28581e&scoped=true&"
import script from "./DetailedDescription.vue?vue&type=script&lang=ts&"
export * from "./DetailedDescription.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedDescription.vue?vue&type=style&index=0&id=ad28581e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad28581e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ad28581e', component.options)
    } else {
      api.reload('ad28581e', component.options)
    }
    module.hot.accept("./DetailedDescription.vue?vue&type=template&id=ad28581e&scoped=true&", function () {
      api.rerender('ad28581e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/DetailedDescription.vue"
export default component.exports